/**
 * P-06/A (D-57) — the milestones of a picker as a tree: each top-level
 * milestone followed by its sub-milestones (one level, D-55), the server's
 * order kept. A sub-milestone whose parent is not in the list stays at the end.
 */
export function milestoneTree<T extends { id: string; parent_milestone_id?: string | null }>(list: readonly T[]): Array<{ m: T; depth: 0 | 1 }> {
  const ids = new Set(list.map((m) => m.id));
  const out: Array<{ m: T; depth: 0 | 1 }> = [];
  for (const m of list) {
    if (m.parent_milestone_id && ids.has(m.parent_milestone_id)) continue;
    out.push({ m, depth: m.parent_milestone_id ? 1 : 0 });
    for (const sub of list) if (sub.parent_milestone_id === m.id) out.push({ m: sub, depth: 1 });
  }
  return out;
}
